import styled, {css} from 'styled-components'
import {Modal, ModalBody, ModalHeader} from '@/components/ui/modal-atoms/ModalAtoms.tsx'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Button} from '@/components/ui/button/Button'

export const StyledNotificationsModal = styled(Modal)(
    ({theme: {spacing}}) => css`
        top: ${spacing * 5}px;
        bottom: ${spacing * 5}px;
        right: ${spacing * 5}px;
        left: unset;
        transform: unset;
        display: grid;
        grid-template-rows: auto minmax(0, 1fr) auto;
        max-height: unset;
    `
)

export const StyledNotificationsModalHeaderWrapper = styled(ModalHeader)`
    display: flex;
    flex-direction: column;
    padding: 0;
`

export const StyledNotificationsModalHeader = styled(ModalHeader)(
    ({theme: {spacing, palette}}) => css`
        background-color: ${palette.neutral[50]};
        display: flex;
        flex-direction: column;
        gap: ${spacing * 4}px;
        padding: ${spacing * 4}px;
    `
)

export const StyledNotificationsModalTitle = styled.h3(
    ({theme: {typography}}) => css`
        ${typography.textXl};
        font-weight: 500;
    `
)

export const StyledNotificationsModalSubheader = styled(Flexbox)(
    ({theme: {palette, spacing, typography}}) => css`
        background-color: ${palette.neutral.white};
        border-radius: 6px;
        padding: ${spacing * 2}px ${spacing * 4}px;

        h4 {
            ${typography.textMd};
            font-weight: 500;
            margin: 0;
        }

        span {
            ${typography.textSm};
            color: ${palette.primary['500']};
            cursor: pointer;
        }
    `
)

export const StyledNotificationsModalBody = styled(ModalBody)`
    padding: 0;
    height: 100%;
`

export const StyledUnreadNotificationButton = styled(Button)(
    ({theme: {palette}}) => css`
        color: ${palette.primary['600']};
    `
)
